@if(isPageInitialized) {
  <div class="dashboard-wrapper" *transloco="let t; prefix: 'accidents.claims'">
  <div class="dashboard-top-section d-flex align-items-center justify-content-between">
    <h1>{{ t('title') }}</h1>

    <div class="search-menu-lists d-flex">
      <div class="filters d-flex align-items-center gap-2">
        <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>

        <div class="common-drop-down date-height">
          <app-date-filter [filter]="dateFilter" [isButtonIntervalSelector]="false"
            [disabledIntervals]="disabledIntervals" [defaultInterval]="defaultInterval"
            (filterChanged)="onDateFilterChange($event)">
          </app-date-filter>
        </div>
      </div>
    </div>
  </div>

  <div class="dashboard-widgets">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-total-claims></app-total-claims>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-total-amount-claimed></app-total-amount-claimed>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-active-claim></app-active-claim>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-rejected></app-rejected>
      </div>
    </div>
  </div>

  <div class="table-section">
    <div class="table-filters d-flex align-items-center justify-content-end gap-2">
      <app-search [placeholder]="t('searchPlaceholder')" [disabled]="isLoading" [searchTerm]="searchTerm"
        (searchTermUpdated)="onSearchTermUpdated($event)">
      </app-search>

      <app-insurance-claim-status-filter [disabled]="isLoading" [selectedStatusId]="statusId"
        (statusChanged)="onStatusChanged($event)">
      </app-insurance-claim-status-filter>
    </div>

    <div class="table-container">
      <div class="table-inner">
        @if (isLoading) {
          <div class="state-overlay">
            <div class="spinner-border"></div>
          </div>
        } @else if (!claims.length) {
          <div class="state-overlay">
            <app-empty-state></app-empty-state>
          </div>
        }

        <table class="claims-table">
          <thead>
            <tr>
              <th class="claim-number">{{ t('table.claimNumber') }}</th>
              <th class="asset">{{ t('table.asset') }}</th>
              <th class="date-filed">{{ t('table.dateFiled') }}</th>
              <th class="category">{{ t('table.category') }}</th>
              <th class="insurance">{{ t('table.insurance') }}</th>
              <th class="attachments">{{ t('table.attachments') }}</th>
              <th class="settled-amount">{{ t('table.settledAmount') }}</th>
              <th class="status">{{ t('table.status') }}</th>
              <th class="actions">{{ t('table.actions') }}</th>
            </tr>
          </thead>
          <tbody>
            @if(!isLoading) {
              @for(claim of claims; track claim.claimId) {
                <tr class="claim-row">
                  <td class="claim-number">{{ claim.claimNumber }}</td>
                  <td class="asset">{{ claim.assetName }}</td>
                  <td class="date-filed">{{ claim.dateFiled | date:'dd/MM/yyyy' }}</td>
                  <td class="category">{{ claim.category || '---' }}</td>
                  <td class="insurance">{{ claim.insurance }}</td>
                  <td class="attachments">
                    <app-attachments-pill
                      [count]="getAttachmentCount(claim)"
                      (pillClick)="onViewAttachments(claim)">
                    </app-attachments-pill>
                  </td>
                  <td class="settled-amount">{{ formatSettledAmount(claim) }}</td>
                  <td class="status">
                    <span class="status-badge" [ngClass]="getStatusClass(claim.status)">
                      @if(claim.status === insuranceClaimStatus.Filed) {
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.3346 5.33203L9.33464 1.33203H4.0013C3.2653 1.33203 2.66797 1.92936 2.66797 2.66536V13.332C2.66797 14.068 3.2653 14.6654 4.0013 14.6654H12.0013C12.7373 14.6654 13.3346 14.068 13.3346 13.332V5.33203ZM6.0013 12.6654H4.66797V6.66536H6.0013V12.6654ZM8.66797 12.6654H7.33464V8.66536H8.66797V12.6654ZM11.3346 12.6654H10.0013V10.6654H11.3346V12.6654ZM9.33464 5.9987C8.96597 5.9987 8.66797 5.9987 8.66797 5.9987V2.66536L12.0013 5.9987H9.33464Z" fill="#3873C9"/>
                        </svg>
                      } @else if(claim.status === insuranceClaimStatus.UnderReview) {
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203ZM10.194 11.1367L7.33203 8.2747V3.9987H8.66536V7.7227L11.1367 10.194L10.194 11.1367Z" fill="#F4BC2B"/>
                        </svg>
                      } @else if(claim.status === insuranceClaimStatus.Rejected) {
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.96736 1.33203C4.3087 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6607 1.33203 7.96736 1.33203ZM8.66536 11.332H7.33203V9.9987H8.66536V11.332ZM8.66536 8.66536H7.33203V4.66536H8.66536V8.66536Z" fill="#FF7F00"/>
                        </svg>
                      } @else if(claim.status === insuranceClaimStatus.InformationRequested) {
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203ZM8.66536 11.332H7.33203V7.33203H8.66536V11.332ZM8.66536 5.9987H7.33203V4.66536H8.66536V5.9987Z" fill="#8A5CF6"/>
                        </svg>
                      } @else if(claim.status === insuranceClaimStatus.Paid) {
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203ZM6.66603 10.9407L4.1907 8.4707L5.13203 7.5267L6.6647 9.0567L10.194 5.52736L11.1367 6.47003L6.66603 10.9407Z" fill="#50AD41"/>
                        </svg>
                      }
                      @if (getStatusLabelKey(claim.status); as labelKey) {
                        <span>{{ labelKey | transloco }}</span>
                      } @else {
                        <span>{{ claim.status || '---' }}</span>
                      }
                    </span>
                  </td>
                  <td class="actions">
                    <span ngbDropdown class="actions-dropdown" [autoClose]="true" placement="bottom-end" container="body">
                      <button type="button" class="btn actions-btn" ngbDropdownToggle>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.9987 5.83203C6.35703 5.83203 5.83203 6.35703 5.83203 6.9987C5.83203 7.64036 6.35703 8.16536 6.9987 8.16536C7.64036 8.16536 8.16536 7.64036 8.16536 6.9987C8.16536 6.35703 7.64036 5.83203 6.9987 5.83203ZM6.9987 2.33203C6.35703 2.33203 5.83203 2.85703 5.83203 3.4987C5.83203 4.14036 6.35703 4.66536 6.9987 4.66536C7.64036 4.66536 8.16536 4.14036 8.16536 3.4987C8.16536 2.85703 7.64036 2.33203 6.9987 2.33203ZM6.9987 9.33203C6.35703 9.33203 5.83203 9.85703 5.83203 10.4987C5.83203 11.1404 6.35703 11.6654 6.9987 11.6654C7.64036 11.6654 8.16536 11.1404 8.16536 10.4987C8.16536 9.85703 7.64036 9.33203 6.9987 9.33203Z" fill="#9FA1A4"/>
                        </svg>
                      </button>
                      <div ngbDropdownMenu class="claim-actions-menu">
                        <button class="dropdown-item" (click)="onEdit(claim)" ngbDropdownItem>{{ t('edit') }}</button>
                        <button class="dropdown-item" (click)="onUpdateClaim(claim)" ngbDropdownItem>{{ t('updateClaim') }}</button>
                      </div>
                    </span>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>

      <div class="table-footer d-flex justify-content-between align-items-center">
        <p class="pagination-text">
          {{ 'common.showingOutOf' | transloco: { current: showingCount, total: totalCount } }}
        </p>

        <app-pagination
          [totalPages]="totalPages"
          [currentPage]="page"
          (pageChange)="goToPage($event)">
        </app-pagination>

        <button class="btn export-btn d-flex align-items-center gap-2 invisible" (click)="onExport()" [disabled]="isLoading && page === 1">
          <span class="text">{{ 'accidents.actions.export' | transloco }}</span>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.41797 9.33463H7.58464V4.08464H9.33464L7.0013 1.16797L4.66797 4.08464H6.41797V9.33463Z" fill="#4D4749"/>
            <path d="M2.91667 12.8333H11.0833C11.7267 12.8333 12.25 12.3101 12.25 11.6667V6.41667C12.25 5.77325 11.7267 5.25 11.0833 5.25H8.75V6.41667H11.0833V11.6667H2.91667V6.41667H5.25V5.25H2.91667C2.27325 5.25 1.75 5.77325 1.75 6.41667V11.6667C1.75 12.3101 2.27325 12.8333 2.91667 12.8333Z" fill="#4D4749"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
  </div>
}